import React, { Component } from 'react';
import { connect } from 'react-redux';
import { Layout, Menu, Icon } from 'antd';
import HeaderComponent from '../../components/HeaderComponent';
import NetworkCenterBasicProfile from './NetworkCenterBasicProfile';
import NetworkCenterFulfilment from './NetworkCenterFulfilment';
import NetworkSpocScreen from './NetworkSpocScreen';
import NetworkCenterSpecialistsScreen from './NetworkCenterSpecialistsScreen';
import NetworkEscalationMatrixScreen from './NetworkEscalationMatrixScreen';
import DocumentsScreen from '../DocumentsScreen';
import NetworkCenterSettlement from './NetworkCenterSettlement';
import NetworkCenterMoUAddScreen from './NetworkCenterMoUAddScreen';
import NetworkVaccination from './NetworkVaccination';
import HospitalDashboard from './HospitalDashboard';
import NetworkEmpanelUser from './NetworkEmpanelUser';
import { fetchCenterBasicProfile } from '../../services';
import SidebarComponent from '../../components/sidebarComponent';
import NetworkProcedures from './NetworkProcedures';
import NetworkCenterOffDates from './NetworkCenterOffDates';

const { Content, Sider } = Layout;

class ProfileScreen extends Component {
  constructor(props) {
    super(props);
    this.state = {
      collapsed: false,
      selectedMenu: 'basicProfile',
      isCenterEnabled: null,
      isEmpanelUser: 0,
      isSidebarOpen: false,
    };

    if (!props.authToken) {
      props.history.push('/');
    }

    if (props.match.params.centerId === 'new') {
      // New Doctor being created
      this.state.centerId = -1;
    } else {
      this.state.centerId = props.match.params.centerId;
    }
  }

  componentDidMount = () => {
    if (this.state.centerId && this.state.centerId !== -1) {
      this.fetchProfile();
    }
  };

  toggleSidebarComponent = () => {
    this.setState((prevState) => ({
      isSidebarOpen: !prevState.isSidebarOpen,
    }));
  };


  fetchProfile = () => {
    this.setState({ loading: true });
    fetchCenterBasicProfile(this.state.centerId)
      .then((res) => {
        const basicProfile = res;
        const { centerDetails } = basicProfile;
        this.setState({
          isEmpanelUser: centerDetails.empanelUserStatus ? 1 : 0,
        });
      })
      .catch((err) => {
        console.log(err);
      })
      .finally(() => {
        this.setState({ loading: false });
      });
  };

  componentDidUpdate(prevProps, prevState) {
    if (prevProps.match.params.centerId !== this.props.match.params.centerId) {
      this.setState({ centerId: this.props.match.params.centerId });
      window.location.reload();
    }
  }

  // onCollapse = collapsed => {
  //   console.log(collapsed);
  //   this.setState({ collapsed });
  // };

  selectMenu = (options) => {
    console.log({ options }, 'select menu');
    this.setState({
      selectedMenu: options.key,
    });
  };
  displayNotesColumn = (flag) => {
    // Hritik Is just Doing some changes
    this.setState({ isCenterEnabled: flag });
    console.log(this.state.isCenterEnabled, 'isCenterEnabled');
  };

  getMouTab = (additionalMenu) => {
    this.getContent(additionalMenu);
  };
  getContent = (additionalMenu) => {
    const { centerId, selectedMenu } = this.state;

    // Determine the menu to render
    const menuToRender = additionalMenu && additionalMenu !== 'backToMenu'
      ? additionalMenu
      : selectedMenu;

    console.log({ selectedMenu, menuToRender }, 'getContent');

    // Render components based on the selected menu
    switch (menuToRender) {
      case 'basicProfile': {
        return (
          <NetworkCenterBasicProfile
            centerId={centerId}
            sendDataToNCB={this.displayNotesColumn}
            isCenterEnabled={this.state.isCenterEnabled}
            setCenterId={(centerId) => {
              this.setState({ centerId });
            }}
          />
        );
      }
      case 'fulfilment': {
        return (
          <NetworkCenterFulfilment
            centerId={centerId}
            getMouTab={this.getMouTab}
            isCenterEnabled={this.state.isCenterEnabled}
            setCenterId={(centerId) => {
              this.setState({ centerId });
            }}
          />
        );
      }
      case 'settlement': {
        return (
          <NetworkCenterSettlement
            centerId={centerId}
            setCenterId={(centerId) => {
              this.setState({ centerId });
            }}
          />
        );
      }
      case 'spocs': {
        return (
          <NetworkSpocScreen
            centerId={centerId}
            setCenterId={(centerId) => {
              this.setState({ centerId });
            }}
          />
        );
      }
      case 'specialists': {
        return (
          <NetworkCenterSpecialistsScreen
            centerId={centerId}
            setCenterId={(centerId) => {
              this.setState({ centerId });
            }}
          />
        );
      }
      case 'empanelUsers': {
        return (
          <NetworkEmpanelUser
            centerId={centerId}
            setCenterId={(centerId) => {
              this.setState({ centerId });
            }}
          />
        );
      }
      case 'escalationMatrix': {
        return (
          <NetworkEscalationMatrixScreen
            centerId={centerId}
            setCenterId={(centerId) => {
              this.setState({ centerId });
            }}
          />
        );
      }
      case 'documents': {
        return <DocumentsScreen centerId={centerId} />;
      }
      case 'mou': {
        return <NetworkCenterMoUAddScreen centerId={centerId} />;
      }
      case 'cashlessVaccinations': {
        return <NetworkVaccination centerId={centerId} />;
      }
      case 'cashlessProcedures': {
        return <NetworkProcedures centerId={centerId} />;
      }
      case 'opdOffDates': {
        return <NetworkCenterOffDates centerId={centerId} />;
      }
      case 'hospitalDashboard': {
        return <HospitalDashboard centerId={centerId} />;
      }
      default: {
        return (
          <NetworkCenterBasicProfile
            centerId={centerId}
            sendDataToNCB={this.displayNotesColumn}
            isCenterEnabled={this.state.isCenterEnabled}
            setCenterId={(centerId) => {
              this.setState({ centerId });
            }}
          />
        );
      }
    }
  };

  render() {
    const { centerId, isSidebarOpen } = this.state;
    return (
      <div>
        <HeaderComponent />
        <div
          style={{
            display: 'flex',
          }}
        >
          <div style={{ zIndex: 1 }}>
            {isSidebarOpen ? (
              <SidebarComponent
                isSidebarOpen={isSidebarOpen}
                toggleSidebar={this.toggleSidebarComponent}
              />
            ) : (
              <Sider
                width={230}
                breakpoint="lg"
                collapsedWidth="0"
                collapsible
                style={{ height: '100%' }}
                // collapsed={this.state.collapsed}
                // onCollapse={this.onCollapse}
              >
                <div className="logo" />
                <Menu
                  theme="dark"
                  defaultSelectedKeys={['basicProfile']}
                  mode="inline"
                  onSelect={this.selectMenu}
                >
                  <Menu.Item
                    key="backToMenu"
                    onClick={this.toggleSidebarComponent}
                  >
                    <Icon type="arrow-left" />
                    <span>Back to Menu</span>
                  </Menu.Item>
                  <Menu.Item key="basicProfile">
                    <Icon type="pie-chart" />
                    <span>Center Profile</span>
                  </Menu.Item>
                  <Menu.Item
                    key="fulfilment"
                    disabled={centerId !== -1 ? false : true}
                  >
                    <Icon type="desktop" />
                    <span>Center Fulfilment</span>
                  </Menu.Item>
                  <Menu.Item
                    key="settlement"
                    disabled={centerId !== -1 ? false : true}
                  >
                    <Icon type="desktop" />
                    <span>Consultation Settlement</span>
                  </Menu.Item>
                  <Menu.Item
                    key="spocs"
                    disabled={centerId !== -1 ? false : true}
                  >
                    <Icon type="desktop" />
                    <span>Center SPOCs</span>
                  </Menu.Item>
                  <Menu.Item
                    key="specialists"
                    disabled={centerId !== -1 ? false : true}
                  >
                    <Icon type="pie-chart" />
                    <span>Center Specialists</span>
                  </Menu.Item>

                  <Menu.Item
                    key="mou"
                    disabled={centerId !== -1 ? false : true}
                  >
                    <Icon type="file-word" />
                    <span>Documents</span>
                  </Menu.Item>
                  <Menu.Item
                    key="cashlessVaccinations"
                    disabled={centerId !== -1 ? false : true}
                  >
                    <Icon type="desktop" />
                    <span>Cashless Vaccinations</span>
                  </Menu.Item>
                  <Menu.Item
                    key="cashlessProcedures"
                    disabled={centerId !== -1 ? false : true}
                  >
                    <Icon type="desktop" />
                    <span>Cashless Procedures</span>
                  </Menu.Item>
                  <Menu.Item
                    key="opdOffDates"
                    disabled={centerId !== -1 ? false : true}
                  >
                    <Icon type="calendar" />
                    <span>OPD Off-Dates</span>
                  </Menu.Item>
                  <Menu.Item
                    key="hospitalDashboard"
                    disabled={centerId !== -1 ? false : true}
                  >
                    <Icon type="desktop" />
                    <span>Manage dashboard</span>
                  </Menu.Item>
                  <Menu.Item
                    key="escalationMatrix"
                    disabled={centerId !== -1 ? false : true}
                  >
                    <Icon type="pie-chart" />
                    <span>Escalation Matrix</span>
                  </Menu.Item>
                  <Menu.Item
                    key="empanelUsers"
                    disabled={
                      centerId !== -1 && this.state.isEmpanelUser == 1
                        ? false
                        : true
                    }
                  >
                    <Icon type="pie-chart" />
                    <span>Special empanelment users</span>
                  </Menu.Item>
                </Menu>
              </Sider>
            )}
          </div>
          <Layout style={{ overflow: 'scroll' }}>
            <Layout style={{ padding: '0 24px 24px' }}>
              <Content
                style={{
                  background: '#fff',
                  padding: 24,
                  margin: 0,
                  minHeight: 280,
                  overflow: 'scroll',
                }}
              >
                {this.getContent()}
              </Content>
            </Layout>
          </Layout>
        </div>
      </div>
    );
  }
}

const mapStateToProps = (state) => ({
  authToken: state.user.authToken,
});

export default connect(mapStateToProps)(ProfileScreen);
